package us.laantech.common.dto

import kotlinx.serialization.Serializable


@Serializable
data class PosConfigDTO(
    val hardwareIdentifier: String,

    // Location
    val latitude: Double? = null,
    val longitude: Double? = null,
    val parentCompanyUuid: String? = null,
    val branchUuid: String? = null,

    // UI
    val storeName: String? = "Store Name Not Set",
    val posName: String? = null,
    val receiptHeaders: List<String>? = emptyList(),
    val receiptFooters: List<String>? = emptyList(),

    // POS
    // TODO migrate to cents
    val cardTransactionRate5dp: Long? = 0L,
    val taxRate5dp: Long? = 0L,
    val cashbackFeeCents: Long? = 0L,
    val cashbackRate5dp: Long? = 0L,

    // System
    val layout: PosButtonLayout? = null
)